import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/organization-attributes/')({
    beforeLoad: () =>
        redirect({
            to: '/admin/organization-attributes/$tab/{-$organizationId}',
            params: { tab: 'attributes-and-preferences' },
            replace: true,
        }),
});
